/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export const EShapeType = {
	CIRCLE: 0,
	RECTANGLE: 1,
	RECTANGLE_ROUNDED: 2,
	TRIANGLE: 3,
	TRIANGLE_ROUNDED: 4,
	LINE: 5,
	IMAGE: 6,
	IMAGE_SDF: 7,
	GROUP: 8,
	BAR: 9,
	LABEL: 10,
	NULL: 11,
	GROUP_SHADOWED: 12,
	LINE_OF_CIRCLES: 13,
	LINE_OF_RECTANGLES: 14,
	LINE_OF_RECTANGLE_ROUNDEDS: 15,
	LINE_OF_TRIANGLES: 16,
	LINE_OF_TRIANGLE_ROUNDEDS: 17,
	EMBEDDED: 18,
	EMBEDDED_LAYER: 19,
	BUTTON: 20,
	RECTANGLE_PIVOTED: 21,
	CONNECTOR_LINE: 22,
	CONNECTOR_ELBOW: 23,
	SEMICIRCLE: 24,
	EMBEDDED_ACCEPTOR_EDGE: 25,
	POLYGON: 26,
	EXTENSION: 1000
} as const;

export type EShapeType = number;
